import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router';
import { Button } from '~/components/ui/button';
import { CollapsibleCard } from '~/components/ui/collapse';
import { DeleteDepositionalWiki } from '~/components/upload/depositional-wiki/delete-depositional-wiki';
import { useRouteParam } from '~/hooks/routing';
import { uploadGeologyRoute } from '~/paths';

export default function UploadDepositionalWikiDeletePage() {
  const navigate = useNavigate();
  const wikiId = useRouteParam('depositionalId', parseInt);

  function handleDeleteSuccess() {
    navigate(uploadGeologyRoute(), { replace: true });
  }

  return (
    <CollapsibleCard title="Delete Depositional Wiki Page">
      <div className="text-center">
        <DeleteDepositionalWiki
          id={wikiId}
          onDeleteSuccess={handleDeleteSuccess}
        >
          {(deleteWiki, loading) => (
            <Button
              type="button"
              color="error"
              onClick={deleteWiki}
              disabled={loading}
              startIcon={<FontAwesomeIcon icon={faTrash} />}
            >
              Delete Wiki Page
            </Button>
          )}
        </DeleteDepositionalWiki>
      </div>
    </CollapsibleCard>
  );
}
